// Smart Magenta -- preco de revenda na pagina do produto. ASCII puro.
// So existe no HTML pra quem tem a etiqueta `revenda`.
(function () {
  var raiz = document.querySelector('.sm-rev');
  if (!raiz) return;
  var linha = document.getElementById('sm-rev-linha');
  var nota = document.getElementById('sm-rev-nota');

  // UF conhecida: endereco padrao do cliente. Vazia enquanto ele nao tiver
  // endereco -- o cadastro de revenda ainda nao pede estado.
  var uf = (raiz.getAttribute('data-uf') || '').toUpperCase();

  // Sobe pra junto da compra, que e onde o preco decide. O bloco nasce no
  // fim da pagina porque o template do produto e nativo e nao aceita HTML
  // nosso entre os blocos dele.
  var compra = document.querySelector('[class*="buy-buttons-block"]');
  if (compra && compra.parentElement) compra.parentElement.insertBefore(raiz, compra);

  function dadosDaVariante() {
    var u = new URL(window.location.href);
    var id = String(u.searchParams.get('variant') || raiz.getAttribute('data-variante') || '');
    var todos = raiz.querySelectorAll('.sm-rev-d');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].getAttribute('data-v') === id) return todos[i];
    }
    return todos[0] || null;
  }

  function pinta() {
    var d = dadosDaVariante();
    if (!d) return;
    var fora = d.getAttribute('data-fora');
    if (!fora) {
      raiz.classList.add('sm-rev-vazio');
      linha.innerHTML = 'Este modelo ainda está sem preço de revenda ' +
        '— vale o público.';
      nota.textContent = '';
      return;
    }
    raiz.classList.remove('sm-rev-vazio');
    var sc = d.getAttribute('data-sc');
    var foraPix = d.getAttribute('data-fora-pix');
    var scPix = d.getAttribute('data-sc-pix');

    if (uf === 'SC') {
      linha.innerHTML = 'Seu preço: <b>' + scPix + '</b> no PIX ' +
        '<span class="sm-rev-ou">ou ' + sc + ' em até 3x</span>';
      nota.innerHTML = 'Entrega em Santa Catarina. Para outros estados, ' +
        foraPix + ' no PIX.';
    } else if (uf) {
      linha.innerHTML = 'Seu preço: <b>' + foraPix + '</b> no PIX ' +
        '<span class="sm-rev-ou">ou ' + fora + ' em até 3x</span>';
      nota.innerHTML = 'Entrega fora de SC. Dentro de Santa Catarina, ' +
        scPix + ' no PIX (ICMS interno).';
    } else {
      // Sem UF ainda: mostra os dois em vez de escolher por conta propria.
      linha.innerHTML = '<b>' + foraPix + '</b> no PIX fora de SC ' +
        '<span class="sm-rev-ou">&middot; ' + scPix + ' dentro de SC</span>';
      nota.innerHTML = 'O valor final depende do estado de entrega — ' +
        'calcule o frete abaixo e o preço se ajusta.';
    }
  }

  // A calculadora de frete descobre a UF pelo CEP; aproveita a mesma.
  document.addEventListener('sm:uf', function (ev) {
    if (ev.detail && ev.detail.uf) { uf = String(ev.detail.uf).toUpperCase(); pinta(); }
  });

  pinta();
  window.addEventListener('popstate', pinta);
  var empurra = history.pushState;
  history.pushState = function () { empurra.apply(this, arguments); pinta(); };
  var troca = history.replaceState;
  history.replaceState = function () { troca.apply(this, arguments); pinta(); };
})();
